import { render, staticRenderFns } from "./MergeCandidates.vue?vue&type=template&id=1f987f42"
import script from "./MergeCandidates.vue?vue&type=script&lang=js"
export * from "./MergeCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports